import React, { useState, useEffect } from 'react';
import classes from './Login.module.css';
import TextLink from '../../components/UI/Texts/TextLink';
import Input from '../../components/UI/Inputs/Input';
import {
  login,
  selectAuthStatus,
  generateBasicAuth,
  selectIsLoggedIn,
} from '../../store/slices/auth';
import { useAppDispatch, useAppSelector } from '../../store/store';
import Spinner from '../../components/UI/Spinner/Spinner';

import PrimaryButtonV2 from '../../components/UI/Buttons/PrimaryButtonV2';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslations';

const Login: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const authStatus: string = useAppSelector<string>(selectAuthStatus);
  const [searchParams] = useSearchParams();
  let redirectFromParam = searchParams.get('redirect') || '';
  const isLoggedIn: boolean = useAppSelector<boolean>(selectIsLoggedIn);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn && redirectFromParam) {
      navigate(`/web/${redirectFromParam}`);
      return;
    }
    if (isLoggedIn) {
      navigate('/web');
    }
  }, []);

  const handleForgotPassword = () => navigate('/web/forgot-password');

  const handleLogin = () => {
    dispatch(
      generateBasicAuth({
        username: email?.trim(),
        password: password?.trim(),
      })
    );
    dispatch(
      login({
        username: email,
        password: password,
      })
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.formContainer}>
        <div className={classes.title}>{translations('login_to_your_account')}</div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            handleLogin();
          }}
        >
          <Input
            placeholder={translations('login.email')}
            label={translations('login.email')}
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            type={'text'}
            id={'email'}
            isSecure={false}
            textarea={false}
            errorText={''}
          />
          <Input
            placeholder={translations('login.password')}
            label={translations('login.password')}
            value={password}
            onChange={(e) => setPassword(e?.target?.value)}
            type={'text'}
            id={'password'}
            isSecure={true}
            textarea={false}
            errorText={''}
          />
          {authStatus === 'pending' ? (
            <Spinner />
          ) : (
            <PrimaryButtonV2
              type="submit"
              text={translations('login')}
              containerStyle={{
                width: '100%',
              }}
              buttonStyle={{
                width: '100%',
              }}
              disabled={email === '' || password === ''}
              onClick={() => {}}
            />
          )}
        </form>

        <div className={classes.loginOptions}>
          <div className={classes.rememberMe}>
            <input type={'checkbox'} />
            {translations('remember.me')}
          </div>
          <div className={classes.forgotPasswordLink}>
            <TextLink
              linkText={translations('login.forgot_password')}
              text={''}
              containerStyle={{ alignItems: 'left' }}
              style={{
                color: '#212459',
                fontWeight: 600,
                fontSize: 16,
                cursor: 'pointer',
              }}
              onClick={handleForgotPassword}
            />
          </div>
        </div>
      </div>
      <div className={classes.registerLink}>
        <p className={classes.registerLinkText}>{translations('not.an.ecocare')}</p>
        <TextLink
          linkText={translations('sign.up')}
          text={''}
          containerStyle={{ alignItems: 'left' }}
          style={{
            color: '#212459',
            fontWeight: 600,
            fontSize: 16,
            marginTop: 0,
            cursor: 'pointer',
          }}
          onClick={() => {}}
        />
      </div>
    </div>
  );
};

export default Login;
